import { Controller } from '@hotwired/stimulus';
import { SELECT_CELL_SAVED_EVENT } from '../../application/toolkit/ag_grid_shared/cell_renderers/status_cell_renderer';

interface MappingSavedDetail {
  response?: { all_columns_mapped?: boolean };
}

/**
 * Owns the "Ensure all the ElectionBuddy options are mapped." notice under the mapping grid.
 * The dropdown itself is the shared StatusCellRenderer; this only reacts to its save event,
 * which is what voter_list_maps/update.js.erb does for the legacy table.
 */
export default class extends Controller {
  static targets: string[] = ['notice'];

  declare readonly noticeTarget: HTMLElement;
  declare readonly hasNoticeTarget: boolean;

  private readonly onMappingSaved = (event: Event): void => {
    if (!this.hasNoticeTarget) return;

    const { detail } = event as CustomEvent<MappingSavedDetail>;
    this.noticeTarget.hidden = detail?.response?.all_columns_mapped === true;
  };

  connect(): void {
    this.element.addEventListener(SELECT_CELL_SAVED_EVENT, this.onMappingSaved);
  }

  disconnect(): void {
    this.element.removeEventListener(SELECT_CELL_SAVED_EVENT, this.onMappingSaved);
  }
}
